import React, { Component } from 'react';
import StepData from 'pattern/StepData.js';
import { connect } from "react-redux";
import Track from 'track/Track.js';
import {DEFAULT_HEIGHT, WIDTH} from './constants.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import PianoRollGridStep from 'components/pianoroll/PianoRollGridStep.js';
import Resolution from 'engine/Resolution.js';
import PianoRollStepsContainer from '../pianoroll2/PianoRollStepsContainer.js';
//import PianoRollStepsContainer from './PianoRollStepsContainer.js';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';

class PianoRollRowComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            triggering: false,
        };
    }

    onMouseLeave(e) {
        if (this.state.triggering) {
            this.triggerRelease(e);

            this.setState({
                triggering: false,
            });
        }
    }

    get transpose() {
        return this.props.note.getTranspose();
    }

    triggerAttack(e) {
        e.stopPropagation();
        let track = this.props.track;
        let stepData = new StepData();
        stepData.copyFrom(track.trackData);
        stepData.transpose = this.transpose;
        stepData.slice = this.sliceNumber;
        stepData.duration = null;
        track.midiEffects.liveInputTrigger(stepData);
        this.setState({
            triggering: true
        });
    }

    triggerRelease(e) {
        e.stopPropagation();
        this.props.track.midiEffects.liveInputRelease(
            this.transpose,
            0);
        this.setState({
            triggering: false
        });
    }

    render() {
        let height = DEFAULT_HEIGHT * this.props.scale;
        if (this.props.track.getEasyPattern().pattern === undefined) {
            return (
                <div></div>
            );
        }
        let width = WIDTH * this.props.xScale * this.props.track.getEasyPattern().pattern.length(this.props.resolution);
        var style = {
            height: height,
            width: width
        };

        let className='piano-roll-row';
        className += this.props.note.isBlackNote() ? ' black' : '';

        let noteClassName = this.props.note.note === 'C' ?
            'note-blank-side note-c' : 'note-blank-side';

        let noteNameClassName = this.props.note.isBlackNote() ? "black-note note-name" : "white-note note-name";

        if (this.state.triggering) {
            noteNameClassName += ' triggering';
        }

        return (
            <div
              draggable={false}
              style={style}
              className={className}>
              <PianoRollStepsContainer
                lastDuration={this.props.lastDuration}
                leftSpace={this.props.leftSpace}
                resolution={this.props.resolution}
                height={height}
                color={this.props.color}
                parentClassName={this.props.parentClassName}
                sequencerEngine={this.props.sequencerEngine}
                track={this.props.track}
                xScale={this.props.xScale}
                noteIndex={this.props.noteIndex}/>
            </div>
        );
    }
}


export default connect(null, null)(PianoRollRowComponent);
